import React from "react";
import {
  FilePdfOutlined,
  IdcardOutlined,
  FileWordOutlined,
  CheckOutlined,
  CopyOutlined,
  FileImageOutlined,
  MailOutlined,
  PhoneOutlined,
  LeftOutlined,
  RightOutlined
} from "@ant-design/icons";
import { Pagination } from "antd";
import moment from "moment";
import { Link, useHistory } from "react-router-dom";

const IMGEXT = ["jpg", "jpeg", "png"];
const WORDEXT = ["doc", "docx"];
const VIDEXT = ["mp4"];

const getSlotTimeStr = (reminder) => {
  const slot = reminder?.slot !== undefined && reminder?.slot !== null ? Number(reminder.slot) : null;
  if (slot === 1) return "10 AM-12 PM";
  if (slot === 2) return "12-2 PM";
  if (slot === 3) return "2-4 PM";
  if (slot === 4) return "4-6 PM";
  if (slot === 5) return "6-7 PM";

  return moment(reminder?.callSchedule || reminder?.slotDate, "YYYY-MM-DD HH:mm:ss").format(
    "hh:mm A"
  );
};

const ReminderSection = ({
  reminders,
  reminderPageNo,
  mobileCopyReminder,
  setReminderPageNo,
  setLogDate,
  logDate,
  setMobileCopyReminder
}) => {
  const history = useHistory();

  const accepted = (_id) => {
    history.push("/candidate/" + _id);
  }

  const { filePath } = reminders

  return (
    <>
      <div class="time-date-filter pl-2 d-flex justify-content-between align-items-center w-100">
        <div className="d-flex align-items-center gap-2">
          <b>
            {moment(logDate).format("DD MMM YYYY")}
            {reminders?.currentDayCount !== undefined ? ` (${reminders.currentDayCount})` : ""}
          </b>
          <span className="d-flex align-items-center gap-1">
            <LeftOutlined
              onClick={() => {
                setLogDate(
                  moment(moment(logDate).clone().subtract(1, "days")).format(
                    "YYYY-MM-DD"
                  )
                );
                setReminderPageNo(1);
              }}
            />
            <RightOutlined
              onClick={() => {
                setLogDate(
                  moment(moment(logDate).clone().add(1, "days")).format(
                    "YYYY-MM-DD"
                  )
                );
                setReminderPageNo(1);
              }}
            />
          </span>
        </div>
      </div>
      <hr class="my-2" />
      {reminders?.interviewLogs && reminders?.interviewLogs?.length !== 0 ? (
        <>
          {reminders?.interviewLogs?.map((reminder, _index) => {
            return (
              <div class="custom-row" key={reminder?._id}>
                <div style={{width:'110px'}} class="time blue-sidebar pl-2">
                  {getSlotTimeStr(reminder)}{" "}
                  <br />
                  <span class="fw-normal">
                    {moment(reminder?.callSchedule || reminder?.slotDate).format("DD MMM YYYY")}
                  </span>
                </div>
                <div style={{width:'330px'}} class="details">
                  <div class="name">
                    <span style={{ textTransform: "capitalize" }}>
                      {reminder?.candidateId?.name || ""}
                    </span>
                    {reminder?.candidateId?.trf
                      ? `, ${reminder?.candidateId?.trf?.title}-${reminder?.candidateId?.trf?.department} (${reminder?.candidateId?.trf?.processName}), ${reminder?.candidateId?.trf?.location}`
                      : ""}
                  </div>
                </div>
                <div style={{width:'350px'}} class="contect-details">
                  <div className="d-flex align-items-center gap-1">
                    <PhoneOutlined style={{ transform: "rotate(100deg)" }} />
                    <span>
                      <b> +91 {reminder?.candidateId?.mobileNo || ""} </b>
                      <button
                        onClick={() => {
                          navigator.clipboard
                            .writeText(reminder?.candidateId?.mobileNo)
                            .then(() => {
                              setMobileCopyReminder(_index);
                            });
                        }}
                        className="d-inline-flex bg-white ml-2 outline-none"
                      >
                        {mobileCopyReminder === _index ? (
                          <span className="mx-2">
                            <span className="text-success ms-2">
                              <span className="bg-success text-white d-inline-flex p-1 rounded-circle mr-2">
                                <CheckOutlined />
                              </span>
                            </span>
                          </span>
                        ) : (
                          <CopyOutlined />
                        )}
                      </button>
                    </span>
                    <img src="copy.svg" alt="" />
                  </div>
                  <div className="d-flex align-items-center gap-1">
                    <MailOutlined />
                    <span>{reminder?.candidateId?.email || ""} </span>
                  </div>
                </div>
                <div className="d-flex gap-1">
                  <span className="word-icon d-flex align-items-center justify-content-center">
                    {filePath?.resumeFilePath ? (
                      <>
                        {filePath?.resumeFilePath?.path
                          ?.split(".")
                          .pop()
                          ?.toLowerCase() === "pdf" && (
                          <span className="pdf-icon d-flex align-items-center justify-content-center">
                            <FilePdfOutlined
                              onClick={async (e) => {
                                const resumeUrl = `/doc/${encodeURIComponent(
                                  filePath?.resumeFilePath?.path
                                )}`;
                                window.open(resumeUrl, "_blank");
                              }}
                              style={{ fontSize: "1.3rem" }}
                            />
                          </span>
                        )}
                        {WORDEXT.includes(
                          filePath?.resumeFilePath?.path
                            ?.split(".")
                            .pop()
                            ?.toLowerCase()
                        ) && (
                          <span className="word-icon d-flex align-items-center justify-content-center">
                            <FileWordOutlined
                              onClick={async (e) => {
                                const resumeUrl = `/doc/${encodeURIComponent(
                                  filePath?.resumeFilePath?.path
                                )}`;
                                window.open(resumeUrl, "_blank");
                              }}
                              style={{ fontSize: "1.3rem" }}
                            />
                          </span>
                        )}
                        {IMGEXT.includes(
                          filePath?.resumeFilePath?.path
                            ?.split(".")
                            .pop()
                            ?.toLowerCase()
                        ) && (
                          <span className="img-icon d-flex align-items-center justify-content-center">
                            <FileImageOutlined
                              onClick={async (e) => {
                                const resumeUrl = `/doc/${encodeURIComponent(
                                  filePath?.resumeFilePath?.path
                                )}`;
                                window.open(resumeUrl, "_blank");
                              }}
                              style={{ fontSize: "1.3rem" }}
                            />
                          </span>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </span>
                    <span className="word-icon d-flex align-items-center justify-content-center">
                    {filePath?.videoFilePath ? (
                      <>
                        {VIDEXT.includes(
                          filePath?.videoFilePath?.path
                            ?.split(".")
                            .pop()
                            ?.toLowerCase()
                        ) && (
                          <span className="word-icon d-flex align-items-center justify-content-center">
                            <FileWordOutlined
                              onClick={async (e) => {
                                const videoUrl = `/doc/${encodeURIComponent(
                                  filePath?.videoFilePath?.path
                                )}`;
                                window.open(videoUrl, "_blank");
                              }}
                              style={{ fontSize: "1.3rem" }}
                            />
                          </span>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </span>
                  <span className="word-icon d-flex align-items-center justify-content-center">
                    <IdcardOutlined
                      style={{ fontSize: "1.3rem" }}
                      onClick={() => {
                        accepted(reminder?.candidateId?._id);
                      }}
                    />
                  </span>
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <>
          <div>
            <p>No record found.</p>
          </div>
        </>
      )}
      <div className="mt-4 d-flex justify-content-end">
        <Pagination
          align="center"
          defaultCurrent={1}
          total={reminders?.interviewLogsCount || 0}
          current={reminderPageNo}
          showSizeChanger={false}
          onChange={(page) => {
            setReminderPageNo(page);
          }}
        />
      </div>
    </>
  );
};

export default ReminderSection;
